import React from 'react';

import {
  styled,
  Button,
  Dialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle,
  Stack
} from '@mui/material';
import _ from 'lodash';
import {
  appEvents,
  fields
} from 'modules';
import { useCharacterCount } from 'modules/layer0/useCharacterCount';

import * as dataService from './dataService';



const ControlledTextField = fields.genTextFieldControllerComponent<dataService.IFormData>();

const DialogActions = styled(MuiDialogActions)({
  margin: 0,
  padding: '8px 24px 16px 24px'
});

const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  minWidth: 420,
  paddingTop: theme.spacing(1),
  marginBottom: theme.spacing(4)
}));



export interface IProps {
  isOpen?: boolean;
  id?: string;
  investorCardId?: string;
}

export const FC: React.FC<IProps> = props => {
  const {
    form,
    loading,
    mutations
  } = dataService.useSaveNote(props.id ?? '');

  const chars = form.watch('body');
  const characterCount = useCharacterCount(chars);



  async function processSubmit(formData: dataService.IFormData) {
    const note = _.merge(
      {
        title: formData.title,
        body: formData.body
      },

      props.id ?
        { id: props.id }
        :
        { investorCardId: props.investorCardId }
    );

    try {
      await mutations.saveNote(note);
      window.localStorage.setItem('isExpanded', 'true');

    } catch (error) {
      alert(error);

    } finally {
      handleClose();
    }
  }



  function handleClose() {
    if (!loading) {
      appEvents.broadcast({
        type: 'modal',
        args: 'close'
      });
    }
  }



  return (
    <Dialog
      open={props.isOpen ?? false}
      onClose={handleClose}
      maxWidth="md">
      <DialogTitle>{props.investorCardId ? 'Add Note' : 'Edit Note'}</DialogTitle>
      <form onSubmit={form.handleSubmit(processSubmit)}>
        <DialogContent>
          <Stack spacing={3}>
            <ControlledTextField
              label="Title"
              isDisabled={loading}
              formControl={form.control}
              fieldKey="title" />

            <ControlledTextField
              label="Note"
              isDisabled={loading}
              numLines={6}
              characterCount={characterCount}
              formControl={form.control}
              fieldKey="body" />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            disabled={loading}
            variant="outlined"
            color="secondary"
            onClick={handleClose}>
              Cancel
          </Button>

          <Button
            type="submit"
            disabled={loading}>
              Confirm
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
